export var PluginType;
(function (PluginType) {
    PluginType["BEFORE"] = "before";
    PluginType["ENRICHMENT"] = "enrichment";
    PluginType["DESTINATION"] = "destination";
})(PluginType || (PluginType = {}));
//# sourceMappingURL=plugin.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amplitude/analytics-types/lib/esm/plugin.js
// module id = 194
// module chunks = 0